import JSEncrypt from 'jsencrypt'

let priKey = 'MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAIUWVOGV+sirTCt00X1Xu2e9lQV5DRYYp/sUYzwaQz1Cbzz0fgk3lqCkMZCSq6inx2R2W1oz6qdSHuyZxlMOP3OkXGF7DnCzMND89MJnevFiXOhtUD8/f5FKxbCEiyI+kj+M20lm7CWQ9lk8XrrnnPttHE6b56+5f8jQeTz/fYiXAgMBAAECgYB4u3qDLyjTdDpkTdRhrf4PrXeMAHWzruhsqOEhO/31i9gX5wCTYf9eebWRHs1k8de7tndHDEP6SFBPeWzmGc3Kxt2WgtIeh7jGlZjzQjWATKOGdQB9NxCjxGlki6dpZHNVCtL59Wyig01A8aFDBOn6ShVK2C4FbrC4mpYHG8qcqQJBAOVtPBn9igVInZJvsrc4qDw6u5Yxiq7tIeBmTI1SrPlK2ADLwyqum2BdbjZnFyy6zbaHOrL0jQ1GEbgNRu6wQNsCQQCUgIVcWBFfi+o9WS0KkodaCa/c6ntviIYRmd13OQ5xBQkBb4nrYZfzq2b+4QAjfvO3a2Ndd/Ukpx+FdB0WMJX1AkAOQ/OHvi8V0wURNObM47X6QMCnPx9bbx07IcFCzFA7E/9IVWMmRUMeA9E1isVzH45o+hGZTQF0QNYbNqAheU4fAkBfaLtF+yceVgxm4fZ4RnBDvtmIe/ZWUEai5FJPmQ7YOj3w+DKKUieIXGVN+E1YgOYgwBQVJ08O/3jXCyTs7sZJAkEAuoLbynQ3A7PV3oUHnEc1kXTBgcmtBTBAcsOVUHYLJhB56iOf/Q/RJ1qeSqUnUSLabXegNcc7cW7gM2+bWYqhMQ=='
let pubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCFFlThlfrIq0wrdNF9V7tnvZUFeQ0WGKf7FGM8GkM9Qm889H4JN5agpDGQkquop8dkdltaM+qnUh7smcZTDj9zpFxhew5wszDQ/PTCZ3rxYlzobVA/P3+RSsWwhIsiPpI/jNtJZuwlkPZZPF6655z7bRxOm+evuX/I0Hk8/32IlwIDAQAB'
let RSA = {
  //使用公钥加密

  jiami(str) {
    let encrypt = new JSEncrypt();
    encrypt.setPublicKey(pubKey);
    let encrypted = encrypt.encrypt(str);
    return encrypted
    console.log('加密后数据:%o', encrypted);
  },
  jiemi(str) {
    //使用私钥解密
    let decrypt = new JSEncrypt();
    decrypt.setPrivateKey(priKey);
    let uncrypted = decrypt.decrypt(str);
    return uncrypted;
    console.log('解密后数据:%o', uncrypted); // 张三

  }
}
export default RSA;


// WEBPACK FOOTER //
// ./src/utils/rsa.js